import { aborted, blocked, completed, failed, partial } from 'flare-chat-core/contracts/chat/operation-result';
import { normalizeArtifactRef } from 'flare-chat-core/contracts/context/artifact-ref';

const validateReference = (reference, base) => {
  const normalized = normalizeArtifactRef(reference);
  const sameArtifact = ['artifact_id', 'artifact_type'].every((key) => normalized[key] === base[key]);
  const sameScope = ['tenant_id', 'project_id'].every((key) => normalized.scope[key] === base.scope[key]);
  if (!sameArtifact || !sameScope) throw new TypeError('Artifact save returned an invalid reference');
};

/** An accepted CAS edit and canonical refresh are separate outcomes. */
export const commitCanvasDraftAppend = async ({ activeSessionId, appendPayload, projectAPI,
  onArtifactEditCommitted, acknowledgedReceipt, signal, isCurrent = () => true }) => {
  const base = appendPayload?.expected_base;
  if (!activeSessionId || !base || typeof projectAPI?.editProjectArtifact !== 'function') {
    return blocked('artifact_save_unavailable');
  }
  if (!isCurrent()) return aborted();
  let receipt = acknowledgedReceipt;
  if (!receipt) {
    try {
      const acknowledgment = await projectAPI.editProjectArtifact(base.scope.project_id, base.artifact_id,
        appendPayload, { signal });
      validateReference(acknowledgment?.artifact_ref, base);
      receipt = { sessionId: activeSessionId, acknowledgment };
    } catch (error) {
      return signal?.aborted ? aborted() : failed(error, 'editProjectArtifact');
    }
  }
  if (!isCurrent()) return aborted(receipt);
  try {
    const refresh = await onArtifactEditCommitted?.(receipt.acknowledgment);
    if (refresh?.status && refresh.status !== 'completed') throw new Error('Canonical refresh did not complete');
  } catch (error) {
    return partial(receipt, error, 'refreshSession');
  }
  return isCurrent() ? completed(receipt) : aborted(receipt);
};
export default commitCanvasDraftAppend;
